import React from "react";
import { X, Trash2, Minus, Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useNavigate } from "react-router-dom";

const PKR = (n) => `Rs ${Number(n || 0).toLocaleString("en-PK")}`;

export default function CartDrawer() {
  const { items, updateQty, remove, subtotal, open, setOpen, keyOf } = useCart();
  const nav = useNavigate();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60]" data-testid="cart-drawer">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setOpen(false)} />
      <aside className="absolute right-0 top-0 h-full w-full sm:w-[420px] bg-[#0f0f12] border-l border-amber-500/20 flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-zinc-800">
          <h3 className="font-serif text-2xl text-amber-200">Your Cart</h3>
          <button data-testid="cart-close-btn" onClick={() => setOpen(false)} className="text-zinc-400 hover:text-white"><X /></button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4 space-y-3">
          {items.length === 0 && <div className="text-zinc-500 text-sm py-20 text-center">Your cart is empty.</div>}
          {items.map((i) => {
            const k = keyOf(i);
            return (
              <div key={k} className="flex gap-3 card-lux p-3" data-testid={`cart-item-${i.item_id}`}>
                {i.image_url && <img src={i.image_url} alt={i.name} className="w-16 h-16 rounded-md object-cover" />}
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-white font-medium line-clamp-1">{i.name}</div>
                  {i.variant && <div className="text-[11px] text-amber-300/80 font-mono">{i.variant}</div>}
                  <div className="mt-1 text-xs text-zinc-400">{PKR(i.unit_price)} each</div>
                  <div className="mt-2 flex items-center gap-2">
                    <button data-testid={`cart-dec-${i.item_id}`} onClick={() => updateQty(k, -1)} className="w-7 h-7 grid place-items-center rounded-full bg-zinc-800 hover:bg-zinc-700"><Minus size={12} /></button>
                    <span className="min-w-[20px] text-center text-sm">{i.quantity}</span>
                    <button data-testid={`cart-inc-${i.item_id}`} onClick={() => updateQty(k, 1)} className="w-7 h-7 grid place-items-center rounded-full bg-zinc-800 hover:bg-zinc-700"><Plus size={12} /></button>
                    <button onClick={() => remove(k)} className="ml-auto text-zinc-500 hover:text-red-400" data-testid={`cart-remove-${i.item_id}`}><Trash2 size={14} /></button>
                  </div>
                </div>
                <div className="text-sm text-amber-200 font-mono">{PKR(i.unit_price * i.quantity)}</div>
              </div>
            );
          })}
        </div>
        <div className="border-t border-zinc-800 p-5 space-y-3">
          <div className="flex justify-between text-sm"><span className="text-zinc-400">Subtotal</span><span className="text-white font-mono">{PKR(subtotal)}</span></div>
          <button
            data-testid="cart-checkout-btn"
            disabled={items.length === 0}
            onClick={() => { setOpen(false); nav("/checkout"); }}
            className="btn-gold w-full"
          >
            Proceed to Checkout
          </button>
        </div>
      </aside>
    </div>
  );
}
